import React from 'react'

import * as S from './styles'

function CardPartner({ data }) {
	const { title, subtitle, description } = data

	return (
		<S.Container>
			<S.TitleContainer>
				<S.Title>{title}</S.Title>
			</S.TitleContainer>
			<S.Content>
				<S.Subtitle>{subtitle}</S.Subtitle>
				<S.Description>{description}</S.Description>
			</S.Content>
		</S.Container>
	)
}

export default CardPartner
